
export default {
  name: 'ProdFilterHeader',
  emits: ['reset'],
  setup (_props, ctx) {
    const handleClick = () => ctx.emit('reset')
    return {
      handleClick,
    }
  },
}
